import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { typeOfAppList } from './common/constants/page-types';
import GlobalStore from './GlobalStore';
import Logger from './common/util/Logger';
import { initialSBFObject } from './common/util/OptimizelyUtil';

const loggerInstance = new Logger('Load App', 'Sfly-Responsive-Pages');

function main() {
    const pageElement = document.getElementsByTagName('responsive-pages')[0];
    const choosedType = pageElement.getAttribute('page-type');
    const isBloomreachEnabled = pageElement.getAttribute('bloomreach-enabled') === 'true';

    if (!typeOfAppList[choosedType]) {
        loggerInstance.error('wrong type: can not find this type');
        throw new Error('wrong type: can not find this type', 'App.js');
    }
    
    const reduxStore = GlobalStore.getStore(choosedType);

    const App = typeOfAppList[choosedType].app;

    ReactDOM.render(
        <Provider store={reduxStore}>
            { App }
        </Provider>,
        document.getElementsByTagName('responsive-pages')[0]
    );
}

module.exports.mount = main;
